import React, { useContext, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import ScDicomCopyToClipboardButton from "../Tools/ScDicomCopyToClipboardButton";
import SaveAsScDicomButton from "../Tools/SaveAsScDicomButton";
import SaveAsPRButton from "../Tools/SaveAsPRButton";
import MarkAsKOButton from "../Tools/MarkAsKOButton";
import { USERTYPES } from "../../../../constants/Constants";
import userContext from "../../../../context/users/UserContext";
//added for quality flag
import useImageQuality from "../../../../hooks/useImageQuality";
import QualityIcon from "../../../../components/QualityIcon/QualityIcon";


const SCDICOMDetails = ({ viewportData, viewportIndex, copyToClipboard, handleUploadScDicom, currentImage }) => {
  const { roles } = useContext(userContext);
  //added for quality flag
  const contextValues = useContext(studyviewerContext) || {};
  const { studyResponseData, priorStudyResponseData } = contextValues;

  const activeData = priorStudyResponseData?.studyDtoList?.length > 0
    ? priorStudyResponseData
    : studyResponseData;

  const { imageErrorsMap } = useImageQuality(activeData);

  const imageId = viewportData?.stack?.images?.[currentImage]?.id;
  const currentImageErrors = imageErrorsMap[String(imageId)] || [];


  return (
    <>
      <div className="viewport-overlay-sc-dicom">
        {viewportData && (
          <>
            {(roles?.includes(USERTYPES.RADIOLOGIST) || roles?.includes(USERTYPES.SUPERVISOR)) && (
              <>
                <span style={{ lineHeight: "15px" }}>
                  <ScDicomCopyToClipboardButton viewportIndex={viewportIndex} copyToClipboard={copyToClipboard} />
                </span>

                <span style={{ lineHeight: "15px" }}>
                  <SaveAsScDicomButton viewportIndex={viewportIndex} handleUploadScDicom={handleUploadScDicom} />
                </span>

            <span style={{ lineHeight: "15px" }}>
            <SaveAsPRButton viewportIndex={viewportIndex} />
            </span>

            <span style={{ lineHeight: "15px" }}>
            <MarkAsKOButton viewportIndex={viewportIndex} />
            </span>

            </>
            )}
            {/* added for quality flag */}
            <span style={{ lineHeight: "15px" }}>
              {currentImageErrors.length > 0 && (
                <QualityIcon errors={currentImageErrors.map(e => e.class ? `${e.class} - ${e.message}` : e.message)} style={{ marginTop: '5px', zoom: 1.3 }} />

              )}
            </span>


          </>
        )}
      </div>
    </>
  );
};

export default SCDICOMDetails;
